var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage"},[_c('hero',{key:_vm.package_type,attrs:{"slider-variant":_vm.slider_variant}}),_c('section',{staticClass:"section section--booking-engine"},[(_vm.is_authenticated())?_c('b-container',[_c('booking-engine',{on:{"search":() => {
            this.$router.push({ name: 'results' });
          }}})],1):_vm._e()],1),(_vm.searching)?_c('section',{staticClass:"section section--loader"},[_c('loader',{attrs:{"size":"large","show_timing_slot":true}})],1):_vm._e(),_c('section',{staticClass:"section"},[_c('b-container',[_c('brands')],1)],1),_c('section',{staticClass:"section"},[_c('b-container',[_c('b-row',_vm._l((_vm.static_blocks),function(block,block_index){return _c('b-col',{key:block_index,attrs:{"lg":"6"}},[_c('div',{staticClass:"section--booking-engine static"},[_c('div',{staticClass:"section--booking-engine__backdrop"},[_c('img',{attrs:{"src":block.image,"alt":""}})]),_c('div',{staticClass:"section--booking-engine__content"},[_c('b-container',{attrs:{"fluid":""}},[_c('vb-icon',{attrs:{"name":'symbol_vv'}}),_c('div',{staticClass:"d-flex flex-column align-items-start"},[_c('div',{staticClass:"section--booking-engine__heading"},[_c('h2',{staticClass:"vb-heading d-inline-block",domProps:{"innerHTML":_vm._s(block.heading)}})]),_vm._l((block.texts),function(text,text_index){return _c('div',{key:text_index,staticClass:"section--booking-engine__text mb-2",class:{ hidden: text.hidden },domProps:{"innerHTML":_vm._s(text.value)}})})],2)],1)],1)]),_c('p',{staticClass:"text mt-4",domProps:{"innerHTML":_vm._s(block.caption)}})])}),1)],1)],1),(_vm.suggestions.length && _vm.is_flight_and_stay_package)?_c('section',{staticClass:"section"},[_c('b-container',[_c('suggestions',{attrs:{"suggestions":_vm.suggestions,"autoplay":_vm.suggestions_autoplay_speed}})],1)],1):_vm._e(),_c('div',{staticClass:"section"},[_c('b-container',[_c('div',{staticClass:"d-flex justify-content-center"},[_c('vb-icon',{staticClass:"mr-3",attrs:{"name":'symbol_vv'}}),_c('h3',{staticClass:"vb-heading",domProps:{"innerHTML":_vm._s('Cerchi solamente un volo?')}})],1),_c('div',{staticClass:"d-flex justify-content-center mt-5"},[_c('a',{attrs:{"href":"https://voli.vadobay.com/","target":"_blank"}},[_c('img',{staticClass:"px-4",attrs:{"src":"assets/images/common/brands/fly-by-payoff.svg","alt":"VadoBay fly by"}})])]),_c('p',{staticClass:"text-center mt-5"},[_vm._v(" Cerca il nostro servizio "),_c('strong',[_vm._v("fly by VadoBay")]),_vm._v(" sul tuo portale welfare. ")])])],1),_c('section',{staticClass:"section"},[_c('b-container',[_c('point-list-01',{attrs:{"pl":[
          {
            pl_icon: 'shield',
            pl_title: 'I migliori brand italiani',
            pl_text:
              'Alpitour, Francorosso, Bravo, Edenviaggi e tanti altri. Il meglio delle vacanze in tutto il mondo.',
          },
          {
            pl_icon: 'happy_pin',
            pl_title: 'Per il welfare aziendale',
            pl_text:
              'Un servizio pensato per un\'utenza aziendale, dal booking online all\'assistenza',
          },
          {
            pl_icon: 'hands',
            pl_title: 'Conferma immediata',
            pl_text:
              'Nessuna burocrazia, nessun rimborso e nessun voucher. Prenoti con un click!',
          },
          {
            pl_icon: 'heart',
            pl_title: 'Come in agenzia ma online',
            pl_text: `Solo su ${_vm.get_config().site.brand} ${_vm.get_config().site.payoff} trovi un\'assistenza attenta e dedicata anche su webchat e WhatsApp`,
          },
        ]}})],1)],1),(_vm.is_authenticated() && _vm.get_config('integration.welfare'))?_c('section',{staticClass:"section"},[_c('image-with-text-cta',{attrs:{"image_src":'assets/images/alpitour/statics/iStock-1180231917.png',"text_heading":'Welfare non sufficiente?',"text_content":'Se il tuo credito welfare non è sufficiente troviamo insieme una soluzione.',"text_cta":[
        {
          cta_text: `Contattaci`,
          cta_icon: 'phone',
          cta_url: `phone:${_vm.get_config().site.phoneNumber}`,
        },
        /*
        {
          cta_text: 'Chat',
          cta_icon: 'chat',
          cta_action: 'support',
          cta_id: 'alpitour-homepage-welfare-chat',
        },
        {
          cta_text: 'Whatsapp',
          cta_icon: 'whatsapp',
          cta_url: get_config().site.waIntentLink,
        },
        {
          cta_text: 'Email',
          cta_icon: 'email',
          cta_url: 'mailto:'+get_config().site.emailSupport,
        }*/
      ]}})],1):_vm._e(),_c('section',{staticClass:"section"},[_c('b-container',[_c('value-proposition',{attrs:{"vp":[
          {
            vp_image: 'assets/images/alpitour/statics/iStock-1208856002.jpg',
            vp_content: [
              {
                vp_icon: 'symbol_vv',
                vp_title: 'Hai bisogno di un consiglio?',
                vp_text:
                  'Se cerchi un suggerimento o la soluzione a tue specifiche esigenze, parla con un nostro consulente. <strong><a href=' +
                  _vm.get_config().site.phoneNumber +
                  '>Chiamaci allo ' +
                  _vm.get_config().site.phoneNumber +
                  '</a></strong>',
              },
              {
                vp_icon: 'symbol_vv',
                vp_title: 'Su di noi puoi contare!',
                vp_text:
                  'Solo Vacanze VadoBay ti offre un\'assistenza multicanale, telefonica, webchat, WhatsApp, email, webcall a portata di click e dedicata a gli utenti di welfare aziendale. ',
                vp_support_action: 'Parla con noi!',
                vp_cta_id: 'alpitour-homepage-vp-multichannel',
              },
            ],
          },
        ]}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }